import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ToggleService {
  private dataSource = new BehaviorSubject(false);
  public data = this.dataSource.asObservable();

  updateData(value: boolean) {
    this.dataSource.next(value);
  }
}
